import {useFormikContext} from "formik";

import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";
import {
    CreateFileMeaningFormValues
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/CreateOrEditFileMeaningDialog";

function AliasField() {
    const {t} = useTranslation();

    const form = useFormikContext<CreateFileMeaningFormValues>();

    const helperText = (form.touched.alias && form.errors.alias) ? t(form.errors.alias) : undefined;

    return (
      <TextField
        name="alias"
        label={t("Alias")}
        variant="outlined"
        onChange={form.handleChange}
        onBlur={form.handleBlur}
        value={form.values.alias}
        fullWidth
        error={form.touched.alias && Boolean(form.errors.alias)}
        helperText={helperText}
        sx={{mb: 2}}
      />
    );
}

export default AliasField;
